var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container my-5"},[(!_vm.loading)?_c('div',{staticStyle:{"margin-bottom":"200px"},domProps:{"innerHTML":_vm._s(_vm.pagina)}}):_vm._e(),(_vm.loading)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }